"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryEnum = exports.ScopeEnum = exports.FactorsEnum = exports.ChannelConfigEnum = exports.ChannelEnum = exports.ConfigEnum = exports.ProvidersEnum = void 0;
var ProvidersEnum;
(function (ProvidersEnum) {
    ProvidersEnum["EmailProvider"] = "emailProvider";
    ProvidersEnum["LDAPProvider"] = "ldapProvider";
    ProvidersEnum["GoogleOAuthProvider"] = "googleOAuthProvider";
    ProvidersEnum["EmailOtpProvider"] = "emailOtpProvider";
    ProvidersEnum["PhoneOtpProvider"] = "phoneOtpProvider";
})(ProvidersEnum || (exports.ProvidersEnum = ProvidersEnum = {}));
//join Factors and Channel
var ConfigEnum;
(function (ConfigEnum) {
    ConfigEnum["Email"] = "email";
    ConfigEnum["Phone"] = "phone";
    ConfigEnum["Google"] = "google";
    ConfigEnum["Apple"] = "apple";
    ConfigEnum["Aletheia"] = "aletheia";
    ConfigEnum["Oauth2"] = "oauth2";
    ConfigEnum["Otp"] = "otp";
    ConfigEnum["Password"] = "password";
    ConfigEnum["Totp"] = "totp";
    ConfigEnum["Code"] = "code";
    ConfigEnum["Secret"] = "secret";
    ConfigEnum["Id_Token"] = "id_token";
    ConfigEnum["Username"] = "username";
})(ConfigEnum || (exports.ConfigEnum = ConfigEnum = {}));
var ChannelEnum;
(function (ChannelEnum) {
    ChannelEnum["Email"] = "email";
    ChannelEnum["Phone"] = "phone";
    ChannelEnum["Google"] = "google";
    ChannelEnum["Apple"] = "apple";
    ChannelEnum["Aletheia"] = "aletheia";
    ChannelEnum["OAUTH2"] = "oauth2";
})(ChannelEnum || (exports.ChannelEnum = ChannelEnum = {}));
var ChannelConfigEnum;
(function (ChannelConfigEnum) {
    ChannelConfigEnum["Google"] = "id_token";
    ChannelConfigEnum["Apple"] = "id_token";
    ChannelConfigEnum["Username"] = "username";
    ChannelConfigEnum["Password"] = "password";
    ChannelConfigEnum["Email"] = "email";
    ChannelConfigEnum["Phone"] = "phone";
})(ChannelConfigEnum || (exports.ChannelConfigEnum = ChannelConfigEnum = {}));
var FactorsEnum;
(function (FactorsEnum) {
    FactorsEnum["OTP"] = "otp";
    FactorsEnum["Password"] = "password";
    FactorsEnum["TOTP"] = "totp";
    FactorsEnum["GOOGLE"] = "google";
    FactorsEnum["APPLE"] = "apple";
})(FactorsEnum || (exports.FactorsEnum = FactorsEnum = {}));
var ScopeEnum;
(function (ScopeEnum) {
    ScopeEnum["CreateSesion"] = "auth.session:create";
    ScopeEnum["CreateAccount"] = "auth.account:create";
})(ScopeEnum || (exports.ScopeEnum = ScopeEnum = {}));
var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum["Employee"] = "employee";
    CategoryEnum["User"] = "user";
})(CategoryEnum || (exports.CategoryEnum = CategoryEnum = {}));
//# sourceMappingURL=index.js.map